import React, { useEffect, useState, useCallback } from "react";
import {
  Badge,
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
} from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ex_years from "../../../assets/images/icons/ex_years.png";
import degree from "../../../assets/images/icons/degree.png";
import Pic from "../../../assets/images/icons/user.png";
import $per_time from "../../../assets/images/icons/$per_time.png";
import { debounce } from "lodash";

import experience from "../../../assets/images/icons/experience.png";
import coached from "../../../assets/images/icons/coached.png";
import earn from "../../../assets/images/icons/earn.png";

import language from "../../../assets/images/icons/language.png";
import sqr_rss from "../../../assets/images/icons/sqr_rss.png";
import sqr_vid from "../../../assets/images/icons/sqr_vid.png";
import range from "../../../assets/images/icons/range.png";
import FrontFilterComponent from "./Filter";
import { useUserContext } from "../../../utils/hooks/UserContext";
import send_img from "../../../assets/images/icons/send.png";
import banner from "../../../assets/images/coach_details_banner.png";
import { followUnfollowCoach, getFilteredCoaches } from "../../../utils/api";
import { toast } from "react-toastify";
import Loader from "../../../Coach/Common/Loader";
import { calculateTotalExperience, getBadgeColor } from "../../../utils/functions";
import { PulseLoader } from "react-spinners";
import LoginComponent from "../Login/newindex";
import { Helmet } from "react-helmet";
import Lottie from "react-lottie";
import noDataLottie from "../../../assets/lottieFiles/noData.json";
import ProfileCard from "../../../components/ProfileCard";

function BrowseCoachListViewComponent() {
  const i = {
    about: "Your about content goes here...",
  };

  const navigate = useNavigate();

  const { user } = useUserContext();
  const [coaches, setCoaches] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [loginModalShow, setLoginModalShow] = React.useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10; // Adjust based on API response
  const [pageSize, setPageSize] = useState(10); // Blogs per page

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: noDataLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  // Filters State
  const [filters, setFilters] = useState({
    positions: [],
    specialities: [],
    languages: [],
    experience: { min: 0, max: 100 },
    cost: { min: 0, max: 100 },
  });

  useEffect(() => {
    const canonicalUrl = window.location.origin + window.location.pathname;
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);

    getData();
    window.scrollTo(0, 0);
  }, [currentPage, filters]);

  const getData = async () => {
    setisLoading(true);
    try {
      const formData = new FormData();

      if (filters.positions.length > 0) {
        formData.append(
          "positions",
          JSON.stringify(filters.positions.map((i) => i.label))
        );
      }
      if (filters.specialities.length > 0) {
        formData.append(
          "specialities",
          JSON.stringify(filters.specialities.map((i) => i.value))
        );
      }
      if (filters.languages.length > 0) {
        formData.append(
          "languages",
          JSON.stringify(filters.languages.map((i) => i.value))
        );
      }
      // Only append experience & cost filters if they are changed from default
      if (filters.experience.min !== 0 || filters.experience.max !== 100) {
        formData.append("min_experience", filters.experience.min);
        formData.append("max_experience", filters.experience.max);
      }
      if (filters.cost.min !== 0 || filters.cost.max !== 100) {
        formData.append("min_cost", filters.cost.min);
        formData.append("max_cost", filters.cost.max);
      }

      // Pagination params
      formData.append("start", (currentPage - 1) * pageSize);
      formData.append("length", pageSize);

      const { data } = await getFilteredCoaches(formData);
      if (data?.status) {
        setCoaches(data?.data);
        setTotalPages(data?.pagination.totalPages || 1);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      // toast.error(error?.response?.data?.message || error?.message)
      console.error("error++", error);
    } finally {
      setisLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (coaches.length > 0) {
      const sortedData = coaches.map((coach) => ({
        ...coach,
        programs: coach.programs?.slice().sort((a, b) => a.price - b.price),
      }));
      setCoaches(sortedData);
    }
  }, []);
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  // const handleFilterChange = (newFilters) => {
  //   setFilters(newFilters);
  //   setCurrentPage(1); // Reset page when filters change
  // };
  const handleFilterChange = (newFilters) => {
    const isEqual = JSON.stringify(newFilters) === JSON.stringify(filters);
    if (!isEqual) {
      setFilters(newFilters);
      setCurrentPage(1);
    }
  };
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleButtonClick = () => {
    console.log("inputValue", inputValue);
  };

  const onClickFollow = async (id) => {
    if (!user) {
      // navigate('/')
      setLoginModalShow(true);
      toast.error("Please login to do this action");
      return;
    }

    const formdata = new FormData();
    formdata.append("coach_id", id);

    await followUnfollowCoach(formdata);
    await getData();
    // console.log('1111');
  };
  const likeButton = async (e) => {
    if (!user) {
      setLoginModalShow(true);
      toast.error("Please login to do this action");
      return;
    }
  };
  const removeHTMLTags = (str) => {
    if (str != null) {
      return str.replace(/<[^>]+>/g, ""); // Remove HTML tags
    }
  };
  const defaultUserImage = (e) => {
    e.target.src = Pic;
  };
  const defaultImage = (e) => {
    e.target.src = "https://admin.qoach.io/assets/images/blog.png";
  };
  return (
    <>
      <Helmet
        htmlAttributes={{ lang: "en" }}
        title="Explore Expert Coaches | Find Your Perfect Match on Qoach"
        meta={[
          {
            name: "description",
            content:
              "Browse profiles of top coaches specializing in various fields. Whether you're seeking career guidance, wellness coaching, or personal development, Qoach has the perfect match for you. Start your journey to success today!",
          },
        ]}
      />
      {loading ? (
        // <PulseLoader color="#36D7B7" loading={loading} size={15} />
        <div
          style={{
            // textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100vw",
          }}
        >
          <p>
            <PulseLoader color="#00504E" size={20} />
          </p>
        </div>
      ) : (
        <>
          <section className="py-3 bg-white mt-[76px]">
            <Container>
              <div className="flex items-center justify-between w-full">
                <div className="d-flex justify-content-start">
                  <FrontFilterComponent
                    filters={filters}
                    setFilters={handleFilterChange}
                  />
                </div>
                <div>
                  <NavLink
                    className="float-right list_grid_view_btn"
                    to="/browse-coach/grid-view"
                  >
                    <svg
                      opacity="0.6"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="20"
                        cy="20"
                        r="18.5"
                        stroke="#964B00"
                        strokeWidth="3"
                      />
                      <g clipPath="url(#clip0_2115_3853)">
                        <path
                          d="M15.8333 10H13.3333C12.4493 10 11.6014 10.3512 10.9763 10.9763C10.3512 11.6014 10 12.4493 10 13.3333V15.8333C10 16.7174 10.3512 17.5652 10.9763 18.1904C11.6014 18.8155 12.4493 19.1667 13.3333 19.1667H15.8333C16.7174 19.1667 17.5652 18.8155 18.1904 18.1904C18.8155 17.5652 19.1667 16.7174 19.1667 15.8333V13.3333C19.1667 12.4493 18.8155 11.6014 18.1904 10.9763C17.5652 10.3512 16.7174 10 15.8333 10ZM17.5 15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H13.3333C12.8913 17.5 12.4674 17.3244 12.1548 17.0118C11.8423 16.6993 11.6667 16.2754 11.6667 15.8333V13.3333C11.6667 12.8913 11.8423 12.4674 12.1548 12.1548C12.4674 11.8423 12.8913 11.6667 13.3333 11.6667H15.8333C16.2754 11.6667 16.6993 11.8423 17.0118 12.1548C17.3244 12.4674 17.5 12.8913 17.5 13.3333V15.8333Z"
                          fill="#964B00"
                        />
                        <path
                          d="M26.6673 10H24.1673C23.2833 10 22.4354 10.3512 21.8103 10.9763C21.1852 11.6014 20.834 12.4493 20.834 13.3333V15.8333C20.834 16.7174 21.1852 17.5652 21.8103 18.1904C22.4354 18.8155 23.2833 19.1667 24.1673 19.1667H26.6673C27.5514 19.1667 28.3992 18.8155 29.0243 18.1904C29.6495 17.5652 30.0007 16.7174 30.0007 15.8333V13.3333C30.0007 12.4493 29.6495 11.6014 29.0243 10.9763C28.3992 10.3512 27.5514 10 26.6673 10ZM28.334 15.8333C28.334 16.2754 28.1584 16.6993 27.8458 17.0118C27.5333 17.3244 27.1093 17.5 26.6673 17.5H24.1673C23.7253 17.5 23.3014 17.3244 22.9888 17.0118C22.6762 16.6993 22.5007 16.2754 22.5007 15.8333V13.3333C22.5007 12.8913 22.6762 12.4674 22.9888 12.1548C23.3014 11.8423 23.7253 11.6667 24.1673 11.6667H26.6673C27.1093 11.6667 27.5333 11.8423 27.8458 12.1548C28.1584 12.4674 28.334 12.8913 28.334 13.3333V15.8333Z"
                          fill="#964B00"
                        />
                        <path
                          d="M15.8333 20.834H13.3333C12.4493 20.834 11.6014 21.1852 10.9763 21.8103C10.3512 22.4354 10 23.2833 10 24.1673V26.6673C10 27.5514 10.3512 28.3992 10.9763 29.0243C11.6014 29.6495 12.4493 30.0007 13.3333 30.0007H15.8333C16.7174 30.0007 17.5652 29.6495 18.1904 29.0243C18.8155 28.3992 19.1667 27.5514 19.1667 26.6673V24.1673C19.1667 23.2833 18.8155 22.4354 18.1904 21.8103C17.5652 21.1852 16.7174 20.834 15.8333 20.834ZM17.5 26.6673C17.5 27.1093 17.3244 27.5333 17.0118 27.8458C16.6993 28.1584 16.2754 28.334 15.8333 28.334H13.3333C12.8913 28.334 12.4674 28.1584 12.1548 27.8458C11.8423 27.5333 11.6667 27.1093 11.6667 26.6673V24.1673C11.6667 23.7253 11.8423 23.3014 12.1548 22.9888C12.4674 22.6762 12.8913 22.5007 13.3333 22.5007H15.8333C16.2754 22.5007 16.6993 22.6762 17.0118 22.9888C17.3244 23.3014 17.5 23.7253 17.5 24.1673V26.6673Z"
                          fill="#964B00"
                        />
                        <path
                          d="M26.6673 20.834H24.1673C23.2833 20.834 22.4354 21.1852 21.8103 21.8103C21.1852 22.4354 20.834 23.2833 20.834 24.1673V26.6673C20.834 27.5514 21.1852 28.3992 21.8103 29.0243C22.4354 29.6495 23.2833 30.0007 24.1673 30.0007H26.6673C27.5514 30.0007 28.3992 29.6495 29.0243 29.0243C29.6495 28.3992 30.0007 27.5514 30.0007 26.6673V24.1673C30.0007 23.2833 29.6495 22.4354 29.0243 21.8103C28.3992 21.1852 27.5514 20.834 26.6673 20.834ZM28.334 26.6673C28.334 27.1093 28.1584 27.5333 27.8458 27.8458C27.5333 28.1584 27.1093 28.334 26.6673 28.334H24.1673C23.7253 28.334 23.3014 28.1584 22.9888 27.8458C22.6762 27.5333 22.5007 27.1093 22.5007 26.6673V24.1673C22.5007 23.7253 22.6762 23.3014 22.9888 22.9888C23.3014 22.6762 23.7253 22.5007 24.1673 22.5007H26.6673C27.1093 22.5007 27.5333 22.6762 27.8458 22.9888C28.1584 23.3014 28.334 23.7253 28.334 24.1673V26.6673Z"
                          fill="#964B00"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2115_3853">
                          <rect
                            width="20"
                            height="20"
                            fill="white"
                            transform="translate(10 10)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </NavLink>
                </div>
              </div>
            </Container>
          </section>

          {isLoading && <Loader />}
          {!isLoading && (
            <section className="pb-4 bg-white">
              <Container>
                <Row className="justify-content-center">
                  <Col lg="12">
                    <Row className="justify-content-between">
                      <Col lg="8">
                        <div className="browse_coach_card_sldr position-relative">
                          {!isLoading && (
                            <OwlCarousel
                              className="owl-theme"
                              //  loop={true} margin="0"
                              //  items="3" dots={false} nav={true}
                              //  navText={['<span class="arrow prev"></span>',
                              //     '<span class="arrow next"></span>']} responsive={
                              //     {
                              //         '1': {
                              //             items: 1
                              //         },
                              //         '800': {
                              //             items: 1
                              //         },
                              //         '1025': {
                              //             items: 1
                              //         }
                              //     }

                              // }
                              loop={false}
                              margin={10}
                              items={1}
                              dots={false}
                              nav={true}
                              navText={[
                                '<span class="arrow prev"></span>',
                                '<span class="arrow next"></span>',
                              ]}
                            >
                              {coaches.length > 0 ? (
                                coaches?.map((i) => (
                                  <div className="item">
                                    <NavLink
                                      to={
                                        !user
                                          ? ""
                                          : `/browse-coach/coach-details/${i?.coach_id}`
                                      }
                                      onClick={!user ? (e) => likeButton() : ""}
                                    >
                                      <div className="transition-all duration-200 browse_coach_list_card">
                                        {i?.background_img && (
                                          <div className="browse_coach_background_bg">
                                            <img
                                              src={`${process.env.REACT_APP_COACH_BG_FOLDER_PATH}${i?.background_img}`}
                                              alt=""
                                            />
                                          </div>
                                        )}
                                        {!i?.background_img && (
                                          <div className="browse_coach_background_bg">
                                            <img src={banner} alt="" />
                                          </div>
                                        )}
                                        <div className="browse_coach_list_card_header ">
                                          <div className="user_img_sm_rnd">
                                            {i?.profile_pic && (
                                              <img
                                                className="m-auto rounded-circle"
                                                src={`${process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH}${i?.profile_pic}`}
                                                alt=""
                                                onError={(e) =>
                                                  defaultUserImage(e)
                                                }
                                              />
                                            )}
                                            {!i?.profile_pic && (
                                              <img
                                                className="m-auto rounded-circle"
                                                src={Pic}
                                                alt=""
                                              />
                                            )}
                                          </div>
                                          <div className="mt-2 text-center">
                                            <h5 className="my-2 fs-28">
                                              {i.name}
                                            </h5>
                                            {i?.skills?.map((i) => {
                                              return (
                                                <label className="fs-14 text_light capitalize-label">
                                                  {i?.name}
                                                </label>
                                              );
                                            })}
                                          </div>
                                          {i?.coach_type && (
                                            <Badge
                                              className={`bcl_badge_type ${getBadgeColor(
                                                i?.coach_type
                                              )}`}
                                            >
                                              {i?.coach_type}
                                            </Badge>
                                          )}

                                          <div className="mt-3 transition-all duration-150 ydm_row justify-content-center">
                                            <div className="d-flex align-items-center">
                                              <div className="mx-4 d-flex align-items-center">
                                                <span className="me-2">
                                                  <img
                                                    src={experience}
                                                    alt=""
                                                  />
                                                </span>
                                                <span className="fw-500 fs-18">
                                                  {/* {i.workexperience > 0
                                                    ? i.workexperience +
                                                      " Years"
                                                    : "0 Years"}{" "} */}
                                                   {calculateTotalExperience(i?.experiences)}
                                                </span>
                                              </div>
                                              <div className="mx-4 d-flex align-items-center">
                                                <span className="me-2">
                                                  <img src={coached} alt="" />
                                                </span>
                                                <span className="fw-500 fs-18">
                                                  {i.followers_count
                                                    ? i.followers_count
                                                    : 0}{" "}
                                                </span>
                                              </div>
                                              <div className="mx-4 d-flex align-items-center ">
                                                <span className="me-2">
                                                  <img src={earn} alt="" />
                                                </span>
                                                <span className="text_brand_color2 fw-600 fs-18">
                                                  {i?.programs?.length === 1
                                                    ? `$${i.programs[0].price}`
                                                    : i?.programs?.length > 1
                                                    ? `$${
                                                        i.programs[0].price
                                                      } - $${
                                                        i.programs[
                                                          i.programs.length - 1
                                                        ].price
                                                      }`
                                                    : ""}
                                                </span>

                                                {/* <span className="text_brand_color2 fw-600 fs-18">${coaches?.programs.lemgth > 0 []</span> */}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="browse_coach_list_card_mid">
                                          <p className="mb-2 fs-14 fw-400 text_brand_color4 text-title">
                                            {i?.about
                                              ? removeHTMLTags(
                                                  i?.about
                                                ).substring(0, 125) + "..."
                                              : ""}
                                          </p>
                                        </div>
                                        <div className="">
                                          <Row>
                                            <Col>
                                              <div className="gap-3 mx-4 d-flex align-items-center">
                                                <span className="">
                                                  <svg
                                                    width="26"
                                                    height="26"
                                                    viewBox="0 0 26 26"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <g clipPath="url(#clip0_10385_9357)">
                                                      <path
                                                        d="M8.32708 9.90208C8.21563 9.41875 7.90729 8.97917 7.45 8.7875C7.23542 8.69792 7.01979 8.65625 6.81146 8.65625C6.09375 8.65625 5.47083 9.15104 5.30833 9.85104L3.625 16.9896H4.66979L5.16875 14.9062H8.41354L8.89479 16.9896H9.95104L8.32708 9.90208ZM5.41771 13.8646L6.32292 10.0865C6.37604 9.85833 6.57708 9.69792 6.81146 9.69792C6.8875 9.69792 6.96667 9.71458 7.04688 9.74896C7.1625 9.79687 7.26875 9.95417 7.31042 10.1354L8.17188 13.8646H5.41667H5.41771Z"
                                                        fill="#808080"
                                                        fill-opacity="0.55"
                                                      />
                                                      <path
                                                        d="M22.8958 4.49219H3.10417C1.66771 4.49219 0.5 5.66094 0.5 7.09635V21.1589H25.5V7.09635C25.5 5.66094 24.3323 4.49219 22.8958 4.49219ZM1.54167 7.09635C1.54167 6.2349 2.24271 5.53385 3.10417 5.53385H12.4792V20.1172H1.54167V7.09635ZM24.4583 20.1172H13.5208V5.53385H22.8958C23.7573 5.53385 24.4583 6.2349 24.4583 7.09635V20.1172Z"
                                                        fill="#808080"
                                                        fill-opacity="0.55"
                                                      />
                                                      <path
                                                        d="M19.7695 8.65625H18.7279V9.69792H15.082V10.7396H21.2945C21.1883 11.6271 20.7841 13.4396 19.2487 14.674C18.5685 14.1271 18.1102 13.4656 17.8018 12.8229H16.6883C17.0133 13.6396 17.5268 14.5208 18.3352 15.2615C17.5029 15.6812 16.4404 15.9479 15.0831 15.9479V16.9896C16.8768 16.9896 18.2299 16.574 19.2497 15.949C20.2695 16.574 21.6216 16.9896 23.4164 16.9896V15.9479C22.0591 15.9479 20.9956 15.6802 20.1643 15.2615C21.7977 13.7646 22.2247 11.6948 22.3362 10.7396H23.4174V9.69792H19.7716V8.65625H19.7695Z"
                                                        fill="#808080"
                                                        fill-opacity="0.55"
                                                      />
                                                    </g>
                                                    <defs>
                                                      <clipPath id="clip0_10385_9357">
                                                        <rect
                                                          width="25"
                                                          height="25"
                                                          fill="white"
                                                          transform="translate(0.5 0.324219)"
                                                        />
                                                      </clipPath>
                                                    </defs>
                                                  </svg>
                                                </span>
                                                {/* {i?.languages?.map((i) => {
                                                                                        return <span className="text_light fw-500 fs-18">
                                                                                            {[i?.name].filter(Boolean).join(" , ")}
                                                                                             </span>
                                                                                    })} */}
                                                <span className="text_light fw-400 fs-14">
                                                  {i?.languages
                                                    ?.map((lang) => lang?.name)
                                                    .filter(Boolean)
                                                    .join(", ") || ""}
                                                </span>
                                              </div>
                                            </Col>
                                            <Col>
                                              <div className="gap-3 d-flex align-items-center">
                                                <span className="">
                                                  <svg
                                                    width="25"
                                                    height="26"
                                                    viewBox="0 0 25 26"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <g clipPath="url(#clip0_10385_9363)">
                                                      <path
                                                        d="M12.5001 12.8242C13.3241 12.8242 14.1297 12.5798 14.8149 12.122C15.5001 11.6642 16.0342 11.0134 16.3496 10.2521C16.6649 9.49071 16.7474 8.65293 16.5867 7.84468C16.4259 7.03642 16.0291 6.29399 15.4463 5.71127C14.8636 5.12856 14.1212 4.73172 13.3129 4.57095C12.5047 4.41018 11.6669 4.49269 10.9055 4.80805C10.1442 5.12342 9.49344 5.65747 9.0356 6.34268C8.57776 7.02788 8.33339 7.83346 8.33339 8.65755C8.33339 9.76262 8.77238 10.8224 9.55378 11.6038C10.3352 12.3852 11.395 12.8242 12.5001 12.8242ZM12.5001 6.57422C12.9121 6.57422 13.3149 6.6964 13.6575 6.92532C14.0001 7.15424 14.2671 7.47962 14.4248 7.8603C14.5825 8.24097 14.6237 8.65986 14.5434 9.06399C14.463 9.46812 14.2646 9.83933 13.9732 10.1307C13.6818 10.4221 13.3106 10.6205 12.9065 10.7009C12.5024 10.7812 12.0835 10.74 11.7028 10.5823C11.3221 10.4246 10.9968 10.1576 10.7678 9.81499C10.5389 9.47239 10.4167 9.0696 10.4167 8.65755C10.4167 8.10502 10.6362 7.57511 11.0269 7.18441C11.4176 6.79371 11.9475 6.57422 12.5001 6.57422ZM21.5209 9.86276L20.7719 9.6138C20.9067 8.44706 20.7933 7.265 20.4392 6.14514C20.0851 5.02529 19.4983 3.99293 18.7172 3.11577C17.9362 2.23861 16.9785 1.53647 15.9071 1.05538C14.8356 0.574289 13.6746 0.325122 12.5001 0.324219C11.3102 0.324678 10.1343 0.58015 9.05154 1.07342C7.96876 1.56669 7.00429 2.28631 6.2231 3.18378C5.44191 4.08125 4.86215 5.13573 4.52288 6.27617C4.18361 7.41661 4.09271 8.61652 4.25631 9.79505C3.25947 9.98092 2.33769 10.4512 1.60214 11.1492C1.09295 11.6333 0.688151 12.2165 0.41264 12.8628C0.137128 13.5091 -0.00327643 14.205 5.80282e-05 14.9076V19.1523C0.00224719 20.2787 0.368591 21.3742 1.04442 22.2753C1.72026 23.1764 2.66934 23.8349 3.75006 24.1523L6.73964 25.0898C7.24179 25.2461 7.76478 25.3252 8.29068 25.3242C8.76776 25.3236 9.24255 25.2584 9.70214 25.1305L15.723 23.3492C16.2593 23.2028 16.8251 23.2028 17.3615 23.3492L19.848 24.1826C20.4608 24.3317 21.0995 24.3398 21.7159 24.2062C22.3323 24.0727 22.9103 23.8009 23.4064 23.4114C23.9025 23.022 24.3036 22.525 24.5797 21.9579C24.8558 21.3908 24.9995 20.7685 25.0001 20.1378V14.7742C24.9977 13.6965 24.6621 12.6459 24.0392 11.7665C23.4163 10.887 22.5367 10.2227 21.5209 9.86276ZM8.08131 4.24297C8.66074 3.66119 9.34936 3.19955 10.1076 2.88456C10.8659 2.56957 11.679 2.40743 12.5001 2.40743C13.3212 2.40743 14.1342 2.56957 14.8925 2.88456C15.6508 3.19955 16.3394 3.66119 16.9188 4.24297C18.0877 5.41916 18.7448 7.00944 18.7469 8.66769C18.7491 10.3259 18.0961 11.9179 16.9303 13.0971L13.2292 16.6961C13.0361 16.8855 12.7763 16.9916 12.5058 16.9916C12.2353 16.9916 11.9755 16.8855 11.7824 16.6961L8.08131 13.1128C6.90992 11.934 6.25246 10.3397 6.25246 8.67787C6.25246 7.01605 6.90992 5.42173 8.08131 4.24297ZM22.9167 20.1378C22.9174 20.4533 22.846 20.7647 22.7081 21.0485C22.5702 21.3323 22.3694 21.5808 22.1209 21.7753C21.8861 21.964 21.6126 22.0987 21.3199 22.1699C21.0272 22.241 20.7224 22.2467 20.4271 22.1867L17.9844 21.3659C17.0605 21.1004 16.0812 21.0947 15.1542 21.3492L9.12923 23.1284C8.55035 23.2881 7.93772 23.2776 7.36464 23.0982L4.35006 22.1607C3.69761 21.972 3.12397 21.5768 2.71527 21.0343C2.30656 20.4919 2.08484 19.8315 2.08339 19.1523V14.9076C2.08105 14.4865 2.16486 14.0694 2.32967 13.6819C2.49447 13.2945 2.73679 12.9448 3.04173 12.6544C3.51908 12.1995 4.12716 11.9058 4.78027 11.8148C5.20017 12.8557 5.82546 13.8012 6.61881 14.5951L10.3344 18.1919C10.9152 18.7606 11.6956 19.079 12.5084 19.079C13.3212 19.079 14.1016 18.7606 14.6824 18.1919L18.3938 14.5846C19.2248 13.7503 19.8686 12.7486 20.2824 11.6461L20.8417 11.8315C21.4484 12.0489 21.9732 12.4481 22.3445 12.9748C22.7159 13.5014 22.9157 14.1298 22.9167 14.7742V20.1378Z"
                                                        fill="#808080"
                                                        fill-opacity="0.55"
                                                      />
                                                    </g>
                                                    <defs>
                                                      <clipPath id="clip0_10385_9363">
                                                        <rect
                                                          width="25"
                                                          height="25"
                                                          fill="white"
                                                          transform="translate(0 0.324219)"
                                                        />
                                                      </clipPath>
                                                    </defs>
                                                  </svg>
                                                </span>
                                                <div
                                                  style={{ textWrap: "wrap" }}
                                                >
                                                  <span className="text_light fw-400 fs-14">
                                                    {[
                                                      i?.country_name,
                                                      i?.state_name,
                                                    ]
                                                      .filter(Boolean)
                                                      .join(", ")}
                                                  </span>
                                                </div>
                                              </div>
                                            </Col>
                                          </Row>
                                          <Row className="mt-4 g-0">
                                            <Col className="d-grid ">
                                              <Button
                                                className="gap-2 interested"
                                                variant="lk_cls"
                                                onClick={(e) => likeButton()}
                                              >
                                                <svg
                                                  width="20"
                                                  height="22"
                                                  viewBox="0 0 20 22"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M8.41533 0.192057C7.42938 0.195333 6.69887 0.369148 6.20034 0.659662C5.69711 0.953247 5.40967 1.35431 5.28132 1.91611C4.95969 3.04027 5.84185 5.6813 6.85301 7.47323H1.945C0.896989 7.47323 0.28504 8.15295 0.0516543 9.04126C-0.0697502 10.1861 -0.0402685 10.9633 0.85134 11.8107C0.52623 12.2721 0.335009 12.8923 0.391723 13.3697C0.614265 14.0815 0.876114 14.3456 1.45797 14.6259C0.842142 15.9517 1.13634 16.8321 1.99109 17.5421C1.72454 18.593 2.03388 19.5245 2.54261 20.1373C2.90109 20.6471 3.78328 20.9404 4.36247 21.1734C6.60613 21.5641 8.3533 21.1341 10.3735 20.5865C11.714 20.2231 13.1764 19.8116 14.9414 19.5686V9.22475H14.2152C12.7279 7.5333 11.2274 5.85185 9.94151 4.40133C9.72163 3.43744 9.45691 2.46621 9.16027 1.64116C8.95881 1.11642 8.77435 0.589066 8.41588 0.192263L8.41533 0.192057ZM17.919 9.22455H15.5294V19.495C16.3385 19.4354 17.1701 19.3637 17.9005 19.3574C18.9152 19.4096 19.3638 18.7755 19.3711 17.9636V10.6732C19.3656 9.68293 18.7829 9.20227 17.919 9.22434V9.22455ZM17.8823 17.1475C18.3696 17.1475 18.7647 17.5416 18.7647 18.0278C18.7647 18.5141 18.3698 18.9082 17.8823 18.9082C17.3951 18.9082 17 18.5141 17 18.0278C17 17.5416 17.3951 17.1475 17.8823 17.1475Z"
                                                    fill="white"
                                                  />
                                                </svg>
                                                <span>Interested</span>
                                              </Button>
                                            </Col>
                                            <Col className="d-grid">
                                              <Button
                                                className="gap-2 not_interested"
                                                variant="lk_cls"
                                              >
                                                <svg
                                                  width="22"
                                                  height="18"
                                                  viewBox="0 0 22 18"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M16.5498 10.1587L20.7532 5.95535M20.7532 5.95535L16.5498 1.75195M20.7532 5.95535H7.09213C4.1903 5.95535 1.83789 8.30778 1.83789 11.2096C1.83789 14.1114 4.1903 16.4638 7.09213 16.4638H12.3464"
                                                    stroke="#CF3838"
                                                    strokeWidth="1.73147"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                  />
                                                </svg>
                                                <span>Not Interested</span>
                                              </Button>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </NavLink>
                                  </div>
                                ))
                              ) : (
                                <Col>
                                  <Lottie
                                    options={defaultOptions}
                                    height={300}
                                    width={400}
                                    isStopped={false}
                                    isPaused={false}
                                  />
                                </Col>
                              )}
                            </OwlCarousel>
                          )}
                        </div>
                      </Col>
                      <Col lg="4">
                        <h4 className="my-3 fs-15 fw-500">Recommended Coach</h4>

                        {coaches
                          ?.filter((_, ind) => ind < 2)
                          .map((i) => {
                            return (
                              // <NavLink to={ !user ? "" : `/browse-coach/coach-details/${i?.coach_id}`"}>
                              <div key={i.id} className="mb-3">
                                <ProfileCard
                                  coach_id={i?.coach_id}
                                  coach={i}
                                  user={user}
                                  defaultUserImage={(e) => defaultUserImage(e)}
                                  Pic={Pic}
                                  ex_years={ex_years}
                                  degree={degree}
                                  $per_time={$per_time}
                                  onClickFollow={onClickFollow}
                                  likeButton={() => {
                                    toast.error(
                                      "Please login to do this action"
                                    );
                                  }}
                                  getBadgeColor={getBadgeColor}
                                  workExperience={calculateTotalExperience(i?.experiences)}
                                />
                              </div>
                            );
                          })}
                        {/* <div className="want_be_coach_card">
                                                <h5 className="fs-18">If you want to achieve excellence, you can get there today</h5>
                                                <p className="fs-12">Helping others achieve their dreams is an excellent way to start.</p>
                                                <div className="d-grid">
                                                    <NavLink variant="light" className="fs-14 btn btn-light" to='/become-a-coach'>Become a Coach</NavLink>
                                                </div>
                                            </div> */}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </section>
          )}
        </>
      )}
      <LoginComponent
        show={loginModalShow}
        onHide={() => setLoginModalShow(false)}
      />
    </>
  );
}

export default BrowseCoachListViewComponent;
